import fetchServer from "../../fetchServer";
import { PDF_API_BASE } from "./pdfApiBase";

/**
 * PATCH /api/v1/credentials/:id — update label, clientId, clientSecret, or enabled.
 * Only sent fields change. Enabling or a new clientSecret clears cooldownUntil/lastError.
 * 404 unknown id; 409 duplicate label or clientId.
 */
export default async function updatePdfCredential(id, data) {
  let result = {
    return: 0,
    msg: "Something went wrong updating PDF credential",
  };

  if (!id) {
    result.msg = "Missing credential id";
    return result;
  }

  try {
    const res = await fetchServer({
      method: "PATCH",
      url: `/api/v1/credentials/${id}`,
      data,
      api: PDF_API_BASE,
    });

    if (res?.data && !res?.data?.error) {
      result = {
        return: 1,
        msg: res.data?.message || "Successful",
        data: res.data?.data ?? res.data,
      };
    } else if (res?.data?.error) {
      result.msg = res.data.error;
    } else if (res?.error) {
      result.msg = res.error;
    } else if (res?.data?.message) {
      result.msg = res.data.message;
    } else if (res?.msg) {
      result.msg = res.msg;
    }
  } catch (err) {
    console.log("Network Error!", err);
  }

  return result;
}
